import { map } from 'rxjs';
import { AGENT_API } from '../AgentAPI';
import { convertUnixToDate } from '@golden/gdk-base';
import { getUnixTime } from 'date-fns';
export function createUserService(api, _trunk) {
    return {
        // players
        getPlayers(payload) {
            const data = {
                ...payload,
                register_start_at: payload.register_start_at ? getUnixTime(+payload.register_start_at) : undefined,
                register_end_at: payload.register_end_at ? getUnixTime(+payload.register_end_at) : undefined
            };
            return api.fetch(AGENT_API.GET_PLAYERS, { data }).pipe(map((res) => {
                return {
                    ...res,
                    data: res.data.map((item) => convertUnixToDate(item, 'register_at', 'last_login_at'))
                };
            }));
        },
        getPlayersSearch(data) {
            return api.fetch(AGENT_API.GET_PLAYERS_SEARCH, { data });
        },
        getPlayersInfo(id) {
            return api.fetch(AGENT_API.GET_PLAYERS_INFO, { config: { urlParams: { id } } }).pipe(map((res) => convertUnixToDate(res, 'register_at', 'last_deposit_at', 'last_login_at')));
        },
        updatePlayersBubbleId(data, id) {
            return api.fetch(AGENT_API.PUT_PLAYERS_BUBBLE_ID, { data, config: { urlParams: { id } } });
        },
        updatePlayersMemo(data, id) {
            return api.fetch(AGENT_API.PUT_PLAYERS_MEMO, { data, config: { urlParams: { id } } });
        },
        validatePlayersBubbleId(data) {
            return api.fetch(AGENT_API.POST_PLAYERS_BUBBLE_ID_VALIDATE, { data });
        },
        triggerDetectPlayerLostAll(data) {
            return api.fetch(AGENT_API.POST_BARRIER_DETECT, { data });
        },
        // agents
        getAgentLayer() {
            return api.fetch(AGENT_API.GET_AGENTS_LAYER);
        },
        getAgents(data, id) {
            return api.fetch(AGENT_API.GET_AGENTS, { data, config: { urlParams: { id } } }).pipe(map((res) => ({ ...res, data: res.data.map(item => convertUnixToDate(item, 'created_at')) })));
        },
        getAgentsInfo(id) {
            return api.fetch(AGENT_API.GET_AGENTS_INFO, { config: { urlParams: { id } } }).pipe(map((res) => convertUnixToDate(res, 'created_at')));
        },
        updateAgents(data, id) {
            return api.fetch(AGENT_API.PUT_AGENTS_INFO, { data, config: { urlParams: { id } } });
        },
        createAgents(data) {
            return api.fetch(AGENT_API.POST_AGENTS_INFO, { data });
        },
        // subAccounts
        getSubAccounts(data) {
            return api.fetch(AGENT_API.GET_SUB_ACCOUNTS, { data });
        },
        getSubAccountsInfo(id) {
            return api.fetch(AGENT_API.GET_SUB_ACCOUNTS_INFO, { config: { urlParams: { id } } });
        },
        updateSubAccounts(data, id) {
            return api.fetch(AGENT_API.PUT_SUB_ACCOUNTS_INFO, { data, config: { urlParams: { id } } });
        },
        createSubAccounts(data) {
            return api.fetch(AGENT_API.POST_SUB_ACCOUNTS_INFO, { data });
        }
    };
}
//# sourceMappingURL=UserService.js.map